import { InternalUserPermission } from '../../../enum/InternalUserPermission'

export enum SidebarMenu {
    Tenants = 'Tenants',
    EtpSync = 'ETP Sync',
    InvoiceDashboard = 'Invoice Dashboard',
    CSDashboard = 'CSDashboard',
    MarkPackagesPaid = 'Mark Packages Paid',
    APIInsights = 'API Insights',
    // TenantAnalytics = 'Onboard Analytics',
    DataPreview = 'Data Preview',
    SupersetPresets = 'Superset Presets',
    HelpVideos = 'Help Videos',
    EmailValidation = 'Email Validation',
    ConfigDocs = 'Config Docs',
    IntegrationInsights = 'Integration Insights',
    ServiceStatus = 'Service Status',
    ErrorStatus = 'Error Dashboard',
    BreachReporting = 'Breach Reporting',
}

export const sidebarList = Object.values(SidebarMenu)

/** Menus listed here are shown only when the user holds the mapped permission (any one, if a list). */
export const MENU_PERMISSIONS: Partial<Record<SidebarMenu, InternalUserPermission | InternalUserPermission[]>> = {
    [SidebarMenu.InvoiceDashboard]: InternalUserPermission.VIEW_INVOICES,
    [SidebarMenu.MarkPackagesPaid]: InternalUserPermission.MARK_PACKAGES_PAID,
    [SidebarMenu.SupersetPresets]: InternalUserPermission.MANAGE_SUPERSET_PRESETS,
    [SidebarMenu.HelpVideos]: [
        InternalUserPermission.UPLOAD_HELP_VIDEOS,
        InternalUserPermission.APPROVE_HELP_VIDEOS,
        InternalUserPermission.EDIT_HELP_VIDEO_CATALOG,
    ],
    [SidebarMenu.EmailValidation]: InternalUserPermission.VIEW_EMAIL_VALIDATION_CREDITS,
}
